import React, { useEffect, useState } from "react";
import Navbar from "../../components/Navbar/Navbar";
import NewsAIArticle from "../../components/NewsArticle/NewsArticle";
import Footer from "../../components/Footer/Footer";
import styles from "./NewsAIView.module.css";

const NewsAIView = () => {
  const [newsData, setNewsData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchNewsData = async () => {
      try {
        const response = await fetch(
          "https://newsapi.org/v2/everything?q=artificial+intelligence&sortBy=popularity&apiKey=fc6d7048793f45bd8ddf92053d25e354"
        );
        const data = await response.json();

        // sanitizing the API data
        let articles = [];
        data.articles.forEach((item) => {
          if (item.author && item.urlToImage) {
            articles.push(item);
          }
        });

        setNewsData(articles);
        setIsLoading(false);
      } catch (error) {
        // console.log("Error:", error);
      }
    };

    fetchNewsData();
  }, []);

  return (
    <div className={styles.newsAIViewContainer}>
      <Navbar />
      <div className={styles.titleContainer}>
        <h1 className={styles.title}>AI News</h1>
      </div>
      {isLoading ? (
        <div>Loading...</div>
      ) : (
        <div className={styles.newsAIList}>
          {newsData &&
            newsData.map((newsArticle, index) => (
              <NewsAIArticle
                index={index}
                key={newsArticle.source.id}
                image={newsArticle.urlToImage}
                author={newsArticle.author}
                title={newsArticle.title}
                content={newsArticle.content}
                url={newsArticle.url}
              />
            ))}
        </div>
      )}
      <Footer />
    </div>
  );
};

export default NewsAIView;
